import { useDraggable, useDroppable } from '@dnd-kit/core';
import { FC, memo } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { Checkbox } from 'src/view/components/Controls/Checkbox/Checkbox';
import Icon from 'src/view/components/Controls/Icon/Icon';
import Label from '~/view/components/Controls/Label';
import { IBranchPaymentTypeOption } from 'src/view/screens/BranchesManagementScreen/screens/BranchEditScreen/types/branchEdit';
import './style.scss';

interface IProps {
  id: number;
  option: IBranchPaymentTypeOption;
  index: number;
  className?: string;
  withDefaultLabel?: boolean;
  error?: boolean;
  onClick: (id: string | number) => void;
}

const PaymentTypeCheckboxOption: FC<IProps> = ({ id, option, index, className, error, withDefaultLabel, onClick }): JSX.Element => {
  const boundData = {
    id: id.toString(),
    data: {
      option,
      index,
    },
  };

  const { attributes, isDragging, listeners, setNodeRef: draggableRef } = useDraggable(boundData);
  const { isOver, setNodeRef: droppableRef } = useDroppable(boundData);

  const wrapperClassNames = ['checkbox-option', className, isOver ? 'droppable' : undefined].join(' ');

  return (
    <div className={wrapperClassNames} ref={isDragging ? draggableRef : droppableRef}>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <div className="cursor-grab" {...listeners} {...attributes}>
        <Icon name={Icons.DragHandHorizontal} size={13} className="color-gray2 mr-2" />
      </div>
      <Checkbox name={id} value={option.status} label={option.type} error={error} labelClassName="family-medium text-size-16" onClick={onClick} />
      {withDefaultLabel && <Label text="default" className="ml-2" />}
    </div>
  );
};

export default memo(PaymentTypeCheckboxOption);
